import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { burgerMenu } from 'store/selectors/selectors'
import { setActivePage, setBurgerOpen } from 'store/slices/burger'

import { AnimationDirection } from '@/shared/ui/Animation/Animation'

export const useBurger = () => {
	const { isOpen, activePage } = useSelector(burgerMenu)
	const dispatch = useDispatch()

	const setPage = (sectionId: string, direction: AnimationDirection) => {
		dispatch(
			setActivePage({
				sectionId,
				direction
			})
		)
	}
	const closeSideBar = useCallback(() => {
		dispatch(setBurgerOpen(false))
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	const openSideBar = () => {
		dispatch(setBurgerOpen(true))
		dispatch(
			setActivePage({
				sectionId: 'main',
				direction: AnimationDirection.Forward
			})
		)
	}

	const openSideBarPage = (sectionId = '') => {
		if (sectionId) {
			dispatch(
				setActivePage({
					sectionId,
					direction: AnimationDirection.Forward
				})
			)
		}
		dispatch(setBurgerOpen(true))
	}

	const isCatalogPage =
		activePage.sectionId !== 'main' &&
		activePage.sectionId !== 'catalog' &&
		activePage.sectionId !== 'region' &&
		activePage.sectionId !== 'enter' &&
		activePage.sectionId !== 'personal'

	return { isOpen, activePage, setPage, openSideBar, closeSideBar, isCatalogPage, openSideBarPage }
}
